module.exports = __webpack_public_path__ + "static/img/activity-20220729.e804e2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-20220729.png
// module id = AmN4
// module chunks = 0